type CtaBandProps = {
  onNotify: (message: string) => void;
};

export default function CtaBand({ onNotify }: CtaBandProps) {
  return (
    <section className="w-full bg-background-100 px-4 pb-16 md:px-6 md:pb-24">
      <div className="relative mx-auto w-full max-w-6xl overflow-hidden rounded-lg bg-primary-600">
        <div className="absolute inset-0 h-full w-full">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20warm%20textured%20background%20of%20layered%20torn%20paper%20in%20deep%20vermillion%20and%20amber%20gold%2C%20soft%20grain%2C%20subtle%20geometric%20collage%2C%20rich%20saturated%20tones%2C%20no%20text&width=1600&height=600&seq=mas-cta-01&orientation=landscape"
            alt="收藏本页随时获取新地址"
            title="爱黑料网新地址 收藏提醒"
            className="h-full w-full object-cover object-top opacity-40"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 via-primary-700/75 to-primary-600/60"></div>

        <div className="relative z-10 flex flex-col items-center gap-6 px-6 py-12 text-center md:flex-row md:justify-between md:px-12 md:py-16 md:text-left">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              把本页加入收藏，新地址不再错过
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
              入口更换时无需重新搜索，回来刷新本页即可看到当前可用的爱黑料网入口与备用地址。
            </p>
          </div>
          <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
            <button
              type="button"
              onClick={() => onNotify("已收藏本页，下次直接从这里进入")}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3.5 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-bookmark-line text-base"></i>
              收藏本页
            </button>
            <button
              type="button"
              onClick={() => onNotify("备用地址已复制，建议同时保存两条以上线路")}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-file-copy-line text-base"></i>
              复制备用地址
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}